import { render } from "./AdminLogsView.vue?vue&type=template&id=4a81e7ae&scoped=true"
import script from "./AdminLogsView.vue?vue&type=script&lang=js"
export * from "./AdminLogsView.vue?vue&type=script&lang=js"

import "./AdminLogsView.vue?vue&type=style&index=0&id=4a81e7ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a81e7ae"]])

export default __exports__